import {BaseApi} from '@/common/api/BaseApi.js';

/**
 * OIDC — Konfiguration des Web-OIDC-Clients (`coaching-web`, Authorization Code + PKCE).
 * OIDC ist der einzige Login-Pfad. Die `redirect_uri` liegt bewusst auf der aktuellen
 * Tenant-Subdomain (`window.location.origin`) — die API leitet daraus den Tenant ab
 * (Branding + Mitgliedschaft) und akzeptiert jede `*.community-coaching.com`-Subdomain.
 */

/** Redirect-URI-Pfad (Origin-Suffix wird API-seitig geprüft). */
export const OIDC_REDIRECT_PATH = '/oauth/callback';

export const oidcSettings = {
  authority: `${BaseApi.ROOT_URL}/oauth`,
  client_id: 'coaching-web',
  redirect_uri: `${window.location.origin}${OIDC_REDIRECT_PATH}`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email offline_access',
  // Resource Indicator (RFC 8707) → Access-Token bekommt aud = Coaching-API.
  resource: BaseApi.ROOT_URL,
};
